import { Cookies } from 'react-cookie';
import { accessTokenGenerate } from 'src/services/auth.service';
import { apiUrls, errorMessages } from './properties';

export function errorHandler(error) {
  let errorMessage: string;
  const cookies = new Cookies();

  if (error?.data) {
    errorMessage = JSON.parse(error.data.message).details.message;
  } else if (error?.response?.data) {
    const isLoggedIn = cookies.get('logged_in');
    if (isLoggedIn) {
      const refreshToken = cookies.get('refresh_token');
      if (refreshToken) {
        accessTokenGenerate();
      } else {
        localStorage.clear();
        window.location.href = apiUrls.LOG_IN;
      }
      errorMessage = errorMessages.SESSION_TIMEOUT;
    } else {
      errorMessage = JSON.parse(error.response.data.message).details.message;
    }
  }

  return errorMessage;
}
